import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

const schema = z.object({
  token: z.coerce.string().optional(),
})

export const exchangeSearchSchema = zodValidator(schema)
export type ExchangeSearchSchema = z.infer<typeof schema>
